import { toAbsoluteUrl } from '../../../../../../_start/helpers';
import { FormImageFieldModal } from '../../../../media-management/components/form-image/FormImageFieldModal';
import { ElementWrapper } from '../../../components/ElementWrapper';
import { TextAreaEdit } from '../../../components/TextAreaEdit';
import { IElement } from '../../../models/Element';
import { ShowcaseWithTextRight } from './ShowcaseWithTextRight';

type ShowcaseWithTextRightFCProps = {
  index: number;
  data: ShowcaseWithTextRight;
  updateData: (body: IElement, index: number) => void;
};

export const ShowcaseWithTextRightFC = ({
  index,
  data,
  updateData,
}: ShowcaseWithTextRightFCProps) => {
  const update = (fieldsToUpdate: Partial<ShowcaseWithTextRight>) => {
    const updatedData = { ...data, ...fieldsToUpdate };
    updateData(updatedData, index);
  };

  return (
    <>
      <FormImageFieldModal
        modalId={`${data.name}-${data.id}`}
        name={`image_preview`}
        altText={`image_preview_alt`}
        captionText={`image_caption`}
        update={update}
      />

      <ElementWrapper elementIndex={index}>
        <div className="case-showcase-with-text-right body-my-8">
          {/* begin::Figure */}
          <div className="case-showcase-with-text-right__figure">
            {data.image_preview ? (
              <div className="overlay">
                <div className="overlay-wrapper">
                  <img
                    alt="dummy"
                    src={data.image_preview}
                    style={{
                      width: '100%',
                      height: '384px',
                      objectFit: 'cover',
                    }}
                  />
                </div>
                <div className="overlay-layer bg-dark bg-opacity-10 flex-column">
                  <div>
                    <button
                      name="image_preview"
                      className="btn btn-primary btn-shadow"
                      onClick={() =>
                        update({
                          image_preview: '',
                          image_preview_alt: '',
                          image_caption: 'Image caption',
                        })
                      }
                    >
                      Remove
                    </button>
                    <label
                      className="btn btn-light-primary btn-shadow ms-2"
                      data-bs-toggle="modal"
                      data-bs-target={`#${data.name}-${data.id}`}
                    >
                      Change
                    </label>
                  </div>

                  <input
                    placeholder="Alt attribute"
                    className="w-50 mt-2 form-control form-control-lg form-control-solid"
                    type="text"
                    value={data.image_preview_alt ?? ''}
                    onChange={(event) =>
                      update({ image_preview_alt: event.target.value })
                    }
                  />
                </div>
              </div>
            ) : (
              <>
                <label
                  data-bs-toggle="modal"
                  data-bs-target={`#${data.name}-${data.id}`}
                >
                  <img
                    src={toAbsoluteUrl('/assets/images/900x630.png')}
                    alt=""
                    style={{
                      width: '100%',
                      height: '384px',
                      objectFit: 'cover',
                    }}
                  />
                </label>
              </>
            )}
          </div>
          {/* end::Figure */}

          {/* begin::Content */}
          <div className="case-showcase-with-text-right__content">
            <TextAreaEdit
              name="title"
              className="content-title"
              value={data.title}
              setValue={update}
            />

            <TextAreaEdit
              name="description"
              className="content-description"
              value={data.description}
              setValue={update}
            />
          </div>
          {/* end::Content */}
        </div>
      </ElementWrapper>
    </>
  );
};
